import Link from 'next/link';

import { Anchor, Card, Group, Pill, Stack, Text } from '@mantine/core';

import { CompanyPartner } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { CompanyLogo } from 'components/company-logo/CompanyLogo';
import { CompanyLogoFallback } from 'components/company-logo/CompanyLogoFallback';
import { useCompanyProfile } from 'hooks/use-company-profile';
import { useIndustryCategories } from 'hooks/use-industry-categories';

const PartnerTeaser = ({ partner, extraButtons }: { partner: CompanyPartner; extraButtons?: React.ReactNode }) => {
    const { company: partnerCompany } = useCompanyProfile(partner.company);

    const viewUrl = partnerCompany ? CompanyHelpers.urls.view(partnerCompany.slug) : partner.linkedin;

    const { subCategories } = useIndustryCategories();

    const partnerSubCategories = partner.categories?.map((id) => subCategories.find((category) => category.id === id));

    return (
        <Card withBorder h="100%" style={{ alignSelf: 'center', justifyContent: 'center', gap: 20 }} ta="center">
            <Stack gap="xs">
                <Card withBorder p={4} w={100} h={100} style={{ alignSelf: 'center', justifyContent: 'center' }}>
                    <CompanyLogo
                        logos={partnerCompany?.logos ?? { small: partner.logo, large: null }}
                        width={90}
                        fallback={<CompanyLogoFallback name={partnerCompany?.name ?? partner.name ?? ''} />}
                    />
                </Card>

                <Text fw={600} fz="md">
                    {partnerCompany?.name ?? partner.name ?? ''}
                </Text>
            </Stack>

            {partner.description && <div style={{ whiteSpace: 'pre-line' }}>{partner.description}</div>}
            {!!partnerSubCategories?.length && (
                <Group gap="xs" justify="center">
                    {partnerSubCategories?.map((category) => (
                        <Pill key={category?.id!} children={category?.name || ''} />
                    ))}
                </Group>
            )}
            {viewUrl && (
                <Anchor component={Link} href={viewUrl} fz="md" fw={700}>
                    View profile
                </Anchor>
            )}
            {extraButtons}
        </Card>
    );
};

export { PartnerTeaser };
